<template>
      <div :class="$style.wrapper">
        <div :class="$style.content">
          <img :class="$style.logo" src="../assets/logoSmithTeam.svg" alt="" />
          <p>Мы модернизируем наш сайт...</p>
          <img :class="$style.duck" src="../assets/duck.gif" alt="">
          <a href="https://t.me/SmithTeamChannel"><button>Перейти в канал</button></a>
        </div>
      </div>
</template>

<script>
</script>

<style module lang="scss">
.wrapper {
  max-width: 1440px;
  margin: 0 auto;
  .content {
    padding: 50px 80px;
    @media (max-width: 1024px) {
      padding: 50px 80px;
    }
    @media (max-width: 768px) {
      padding: 30px 50px;
      }
      @media (max-width: 480px) {
        padding: 30px 30px;
      }
  }
    .logo {
      display: flex;
      justify-content: flex-start;
      flex-shrink: 0;
      width: 50px;
      height: 50px;
      margin: 0 0 150px 0;
      @media (max-width: 480px) {
        width: 40px;
        height: 40px;
      }
    }
    p {
      font-size: 20px;
      font-weight: 500;
      color: white ;
      text-align: center;
      margin-bottom: 50px;
    }
    .duck {
      display: flex;
      margin: 0 auto;
      height: 150px;
      width: 150px;
      margin-bottom: 50px;
    }
    a {
      text-decoration: none;
    }
    button {
      display: flex;
      margin: 0 auto;
      background-color: #300eff;
      color: white ;
      padding: 10px 24px;
      border-radius: 50px;
      font-weight: 600;
      font-size: 15px;
      letter-spacing: 0.5px;
      text-transform: uppercase;
    }
}
</style>
